import { MixedSchema } from '@principle-theorem/editor';
import {
  ReferralContextBuilder,
  ScopeDataBuilder,
  compileTemplate,
  compileTemplateSchema,
} from '@principle-theorem/principle-core';
import {
  IPractice,
  IReferral,
} from '@principle-theorem/principle-core/interfaces';
import { Firestore, WithRef } from '@principle-theorem/shared';

export interface IReferralEmailTemplateDefaults {
  defaultContent: MixedSchema | undefined;
  defaultSubject: string | undefined;
}

export async function resolveReferralEmailTemplateDefaults(
  referral: WithRef<IReferral>,
  practice: WithRef<IPractice>,
  appUrl: string
): Promise<IReferralEmailTemplateDefaults> {
  const isInitialSend = !referral.emailInvitationSent;
  const templateSlot = isInitialSend
    ? practice.settings?.referral?.emailTemplateDefaults?.initialSend
    : practice.settings?.referral?.emailTemplateDefaults?.updateNotification;

  if (!templateSlot?.templateRef && !templateSlot?.subject) {
    return { defaultContent: undefined, defaultSubject: undefined };
  }

  const scopeData = await ScopeDataBuilder.buildReferralScopeData(
    referral,
    practice,
    appUrl
  );
  const context = new ReferralContextBuilder(scopeData).build();

  let defaultContent: MixedSchema | undefined;
  let defaultSubject: string | undefined;

  if (templateSlot.templateRef) {
    const templateDoc = await Firestore.safeGetDoc(templateSlot.templateRef);
    if (templateDoc && !templateDoc.deleted) {
      defaultContent = compileTemplateSchema(templateDoc.content, context);
    }
  }

  if (templateSlot.subject) {
    defaultSubject = compileTemplate(templateSlot.subject, context);
  }

  return { defaultContent, defaultSubject };
}
